var ZIndexValues = {
  Page: 1,
  Notification: 4000,
  Modal: 5000,
  Tooltip: 6000
};
export function ZIndex(layerName) {
  var zIndexValue = ZIndexValues[layerName];

  if (!zIndexValue) {
    throw new Error("ZIndex: Layer with name ".concat(layerName, " does NOT exist. Layers = ").concat(Object.keys(ZIndexValues).join(', ')));
  }

  return zIndexValue;
}